import React, { Component } from 'react';

import * as api from './api';
import ConversationTab from './components/ConversationTab';
import FaqTab from './components/FaqTab';
import PromptTab from './components/PromptTab';
import SettingTab from './components/SettingTab';
import './customerSupportBot.css';

const TABS = [
    { value: 'CONVERSATION', label: 'Hội thoại', icon: 'fa-solid fa-inbox' },
    { value: 'FAQ', label: 'Kho câu trả lời', icon: 'fa-solid fa-book' },
    { value: 'PROMPT', label: 'Nội dung & chạy thử', icon: 'fa-solid fa-flask' },
    { value: 'SETTING', label: 'Cấu hình', icon: 'fa-solid fa-sliders' },
];

/**
 * Trang quản trị chatbot CSKH tự động trả lời ngoài giờ hành chính.
 *
 * Mặc định mở tab hội thoại vì việc đầu tiên mỗi sáng của nhân viên là xem đêm qua chatbot bí ở đâu.
 */
export default class CustomerSupportBotPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'CONVERSATION',
            setting: null,
            pendingCount: null,
        };
    }

    componentDidMount() {
        this.refreshStatus();
    }

    /**
     * Trạng thái bật/tắt và số việc đang chờ hiện ở đầu trang trong mọi tab: sửa cấu hình hay thêm
     * FAQ mà không biết chatbot đang tắt là hiểu nhầm tốn thời gian nhất ở trang này.
     */
    refreshStatus = () => {
        api.getSetting()
            .then((setting) => this.setState({ setting: setting || {} }))
            .catch(() => this.setState({ setting: null }));

        api.statsConversation()
            .then((stats) => this.setState({
                pendingCount: (stats && stats.counts && stats.counts.NEED_AGENT) || 0,
            }))
            .catch(() => this.setState({ pendingCount: null }));
    };

    renderStatus() {
        const { setting } = this.state;

        if (!setting) {
            return (
                <span className="cs-status cs-status--unknown">
                    <span className="cs-status__dot" />
                    Chưa đọc được trạng thái
                </span>
            );
        }

        const isActive = setting.isActive === true;
        const alwaysOn = setting.alwaysOn === true;
        const startHour = setting.startHour ?? 22;
        const endHour = setting.endHour ?? 8;

        return (
            <span className={`cs-status ${isActive ? 'cs-status--on' : 'cs-status--off'}`}>
                <span className="cs-status__dot" />
                {isActive ? 'Chatbot đang bật' : 'Chatbot đang tắt'}
                {isActive && (
                    <span style={{ fontWeight: 400, opacity: .85 }}>
                        ·{' '}
                        {alwaysOn
                            ? 'cả ngày'
                            : `${String(startHour).padStart(2, '0')}:00–${String(endHour).padStart(2, '0')}:00`}
                    </span>
                )}
            </span>
        );
    }

    renderTab() {
        switch (this.state.activeTab) {
            case 'FAQ':
                return <FaqTab />;
            case 'PROMPT':
                return <PromptTab />;
            case 'SETTING':
                return <SettingTab onSettingChanged={this.refreshStatus} />;
            default:
                return <ConversationTab onDataChanged={this.refreshStatus} />;
        }
    }

    render() {
        const { activeTab, pendingCount } = this.state;

        return (
            <div id="content">
                <div className="cs-page">
                    <div className="cs-header">
                        <div className="cs-header__title">
                            <span className="cs-header__icon">
                                <i className="fa-solid fa-headset" />
                            </span>
                            <div>
                                <h1>Chatbot Chăm sóc khách hàng</h1>
                                <div className="cs-header__sub">
                                    Tự động trả lời tin nhắn gửi tới tài khoản CSKH ngoài giờ hành chính
                                </div>
                            </div>
                        </div>
                        {this.renderStatus()}
                    </div>

                    <div className="cs-tabs">
                        {TABS.map((tab) => (
                            <button
                                type="button"
                                key={tab.value}
                                className={`cs-tab ${activeTab === tab.value ? 'is-active' : ''}`}
                                onClick={() => this.setState({ activeTab: tab.value })}
                            >
                                <i className={tab.icon} />
                                {tab.label}
                                {tab.value === 'CONVERSATION' && pendingCount > 0 && (
                                    <span className="cs-tab__count">{pendingCount}</span>
                                )}
                            </button>
                        ))}
                    </div>

                    {this.renderTab()}
                </div>
            </div>
        );
    }
}
